import { createCachedSelector, } from 're-reselect';
import { searchParamsToString, } from '@moderepo/mode-data-state-base';
/**
 * This is the actual function that will get the data from the state and return the data requested. However, this function returns a new
 * object every time which can cause an infinite loop in re-rendering if used in React component. Therefore this function is not EXPORTED
 * and we will create another function below which use memoize to cache the result.
 */
const selectFirmwareChannelsFunc = (channelsByProjectIdByDeviceClassId, channelIdsByProjectId, projectId, searchParams) => {
    var _a;
    const channelIdsByProjectIdBySearchParams = (_a = channelIdsByProjectId[projectId]) === null || _a === void 0 ? void 0 : _a[searchParams];
    const channelsByProjectId = channelsByProjectIdByDeviceClassId[projectId];
    if (channelIdsByProjectIdBySearchParams && channelsByProjectId) {
        // This will return a new array of Channel which can cause infinite loop if we don't use memoize
        return channelIdsByProjectIdBySearchParams.reduce((result, channelId) => {
            const channel = channelsByProjectId[channelId];
            if (channel) {
                return [
                    ...result,
                    channel,
                ];
            }
            return result;
        }, []);
    }
    return undefined;
};
/**
 * Select ALL Firmware channels for a specific project filtered by deviceClass
 * @param state
 * @param projectId
 * @param deviceClass
 * @returns FirmwareChannel[] | undefined
 */
export const selectFirmwareChannels = createCachedSelector((state) => { return state.firmware.channelsByProjectIdByDeviceClassId; }, (state) => { return state.firmware.channelIdsByProjectId; }, (state, projectId) => { return projectId; }, (state, projectId, deviceClass) => {
    return searchParamsToString({
        deviceClass,
    });
}, selectFirmwareChannelsFunc)((state, projectId, deviceClass) => {
    // use searchParams as cache key for create CachedSelector
    return searchParamsToString({
        deviceClass,
    });
});
/**
 * @param state
 * @param projectId
 * @param channelId
 * @returns FirmwareChannel | undefined
 */
export const selectFirmwareChannelById = (state, projectId, channelId) => {
    var _a;
    return (_a = state.firmware.channelsByProjectIdByDeviceClassId[projectId]) === null || _a === void 0 ? void 0 : _a[channelId];
};
/**
 * This is the actual function that will get the data from the state and return the data requested. However, this function returns a new
 * object every time which can cause an infinite loop in re-rendering if used in React component. Therefore this function is not EXPORTED
 * and we will create another function below which use memoize to cache the result.
 */
const selectFirmwareBundlesFunc = (bundlesByProjectIdByDeviceClassId, bundleIdsByProjectId, projectId, searchParams) => {
    var _a;
    const bundleIdsByProjectIdBySearchParams = (_a = bundleIdsByProjectId[projectId]) === null || _a === void 0 ? void 0 : _a[searchParams];
    const bundlesByProjectId = bundlesByProjectIdByDeviceClassId[projectId];
    if (bundleIdsByProjectIdBySearchParams && bundlesByProjectId) {
        // This will return a new array of Bundles which can cause infinite loop if we don't use memoize
        return bundleIdsByProjectIdBySearchParams.reduce((result, bundleId) => {
            const bundle = bundlesByProjectId[bundleId];
            if (bundle) {
                return [
                    ...result,
                    bundle,
                ];
            }
            return result;
        }, []);
    }
    return undefined;
};
/**
 * Select ALL Firmware bundles for a specific project filtered by deviceClass
 * @param state
 * @param projectId
 * @param deviceClass
 * @returns FirmwareBundle[] | undefined
 */
export const selectFirmwareBundles = createCachedSelector((state) => { return state.firmware.bundlesByProjectIdByDeviceClassId; }, (state) => { return state.firmware.bundleIdsByProjectId; }, (state, projectId) => { return projectId; }, (state, projectId, deviceClass) => {
    return searchParamsToString({
        deviceClass,
    });
}, selectFirmwareBundlesFunc)((state, projectId, deviceClass) => {
    // use searchParams as cache key for create CachedSelector
    return searchParamsToString({
        deviceClass,
    });
});
/**
 * @param state
 * @param projectId
 * @param bundleId
 * @returns FirmwareBundle | undefined
 */
export const selectFirmwareBundleById = (state, projectId, bundleId) => {
    var _a;
    return (_a = state.firmware.bundlesByProjectIdByDeviceClassId[projectId]) === null || _a === void 0 ? void 0 : _a[bundleId];
};
